import styled, { css } from "styled-components";
import theme from "../../../Themes/light";
import { HtmlHTMLAttributes } from "react";

const { colors } = theme;

const commonStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .descricao-texto{
    color: ${(props) => props.theme.colors.tertiary};
    text-align: left;
    padding: 5rem 0;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      height: 2px;
      border-radius: 100%;
      background-color: ${(props) => props.theme.colors.elements};
    }
  }

  .togglesContainer{
    width: 100%;
    padding: 4rem 0;

    .toggleCartao,.togglePix{
      display: flex;
      justify-content: space-between;
      padding: 0 0 2rem;

      .cartao, .pix{
        font-weight: 700;
      }
    }
    .togglePix{
      padding: 2rem 0;
    }

    .configsCartaoContainer{
      display: flex;
      align-items: center;
      gap: 2rem;
      @media (max-width: 768px) {
        flex-direction: column;
      }
    }

    .cancelamentoContainer {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      padding-top: 3rem;

      .cancelamentoToggle {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .cancelamentoInfo {
        font-size: 10px;
        color: #888;
        text-align: left;
      }
    }

    .jurosParcelasSection {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;
      padding-top: 2rem;

      .jurosParcelasGrid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 1rem;
        width: 100%;

        .jurosInputWrapper {
          position: relative;

          .jurosPrefix {
            position: absolute;
            left: 3px;
            bottom: 3px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            pointer-events: none;
            z-index: 2;
            color: #636466;
            font-size: 10px;
            width: 30px;
            background-color: #f6f6f6;
            border-radius: 50%;

            @media(max-width: 1280px){
              height: 25px;
              width: 25px;
            }
          }

          .jurosInput {
            padding-left: 6.8rem !important;
          }
        }

        @media (max-width: 768px) {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
`;

const PagamentoMercadoPagoContainer = styled.div<{
  configIn: "empresa" | "configuracoes" | "catalogo";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    (configIn === "configuracoes" || configIn === "catalogo") &&
    css`
      color: ${(props) => props.theme.colors.tertiary};
      .descricao {
        width: 100%;
        padding: 2rem 0 0 0;
        color: ${(props) => props.theme.colors.tertiary};
        text-align: left;
      }
    `}
`;

export { PagamentoMercadoPagoContainer };
